export default "__VITE_ASSET__SZNI58yZ__"